export default __webpack_public_path__ + "static/media/amex-logo.381dea23.svg";